export const GET_COMPANY_INFO = 'GET_COMPANY_INFO';
export const GET_COMPANY_INVESTORS = 'GET_COMPANY_INVESTORS';
export const GET_DOCUMENTS_INFO = 'GET_DOCUMENTS_INFO';
export const GET_FUNDING_DATA = 'GET_FUNDING_DATA';
export const GET_COMPANY_MEMBERS = 'GET_COMPANY_MEMBERS';
export const SAVE_ALL_DATA = 'SAVE_ALL_DATA';
export const SET_IS_SAVING = 'SET_IS_SAVING';
export const SET_USER_SIGNED_IN = 'SET_USER_SIGNED_IN';
export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';
export const ALL_DATA_SAVED = 'ALL_DATA_SAVED';
export const SET_FORM_DIRTY = 'SET_FORM_DIRTY';
export const UPDATE_COMPONENTS_COUNTER = 'UPDATE_COMPONENTS_COUNTER';
export const UPDATE_VALIDATION_COUNTER = 'UPDATE_VALIDATION_COUNTER';
export const RESET_LOCAL_STATE = 'RESET_LOCAL_STATE';
export const RESTORE_LOCAL_STATE = 'RESTORE_LOCAL_STATE';
export const GET_COMPANY_TOP_INVESTORS = 'GET_COMPANY_TOP_INVESTORS';
export const UPDATE_COMPANY_FOLLOWERS = 'UPDATE_COMPANY_FOLLOWERS';
